import { QueryClient } from '@tanstack/react-query'
import { AppError } from '@/lib/errors/appError'

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          const appError = AppError.fromUnknown(error)
          if (!appError.isRetryable) return false
          return failureCount < 2
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
        throwOnError: (error) => AppError.fromUnknown(error).isFatal,
      },
      mutations: {
        retry: false,
      },
    },
  })
}
